<template>
  <div class="container">
    <div v-if="loaderFeed">
      <marquee
        v-for="(feed, key) in loaderFeed"
        :key="key"
        behavior="alternate"
        direction="right"
        >{{ feed.event }}: {{ feed.message }}</marquee
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderSemantic',
  data() {
    return {
      loaderFeed: {},
    };
  },
  watch: {

  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      const fee = [];
      if (mutation.type === 'START_LOADER' || mutation.type === 'END_LOADER') {
        const loaderRawFeed = this.$store.state.loaderFeed;

        Object.keys(loaderRawFeed).forEach((feed) => {
          fee.push(loaderRawFeed[feed]);
        });
        // console.log(fee);
        this.loaderFeed = fee;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  // watch: {
  //   '$store.state.loaderFeed': {
  //     handler(val) {
  //       this.loaderFeed = val;
  //       console.log(this.loaderFeed);
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
</style>
